import React from 'react';
import CandidateGroupTableRows from './CandidateGroupTableRows';

interface CandidateGroupTableRowsWrapperProps {
  props: any;
  onViewPool: (poolId: number) => void;
  expandedPools: Set<number>;
  onTogglePoolsExpansion: (candidateGroupId: number) => void;
}

const CandidateGroupTableRowsWrapper: React.FC<CandidateGroupTableRowsWrapperProps> = ({
  props,
  onViewPool,
  expandedPools,
  onTogglePoolsExpansion
}) => (
  <CandidateGroupTableRows
    {...props}
    onViewPool={onViewPool}
    expandedPools={expandedPools}
    onTogglePoolsExpansion={onTogglePoolsExpansion}
  />
);

export default CandidateGroupTableRowsWrapper;
